import React from 'react'

const About = () => {
  return (
    <section className='section about-section'>
      <h1 className='section-title'></h1>
      <p>To check whether your version of React Router DOM has the Switch component or not, you can refer to the official documentation or the package's release notes. Here's how you can do it:

        Official Documentation: Visit the React Router DOM documentation website and navigate to the section corresponding to the version you're using. Check the API reference or the guide to see if Switch is mentioned.

        Package.json: Look into your project's package.json file to see the version of React Router DOM you've installed. If you're using npm, you can use the following command:</p>

    </section>
  )
}

export default About
